import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Redirect, useHistory } from 'react-router-dom'
import AdSummary from "../ads/AdSummary";
import venmoQR from '../../images/venmoQR.png'

function Support(){


  return (
    <div style={{display:"flex", flexFlow:"column", margin:'auto', maxWidth:'500px'}}>
      {/*<div style={{'textAllign':'center', "display": "flex", "justifyContent": "center", "padding": "10px"}}>
        <div>
          <h1>Support</h1>
          <p>If you would like to support this project, check out these offers.</p>
        </div>
      </div>*/}
      
      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        <div>
          <h2>Webull</h2>
          <p>This is the best option for both you and me if you want to support my project.</p>
          <p>This just uses a referral link when you sign up for Webull, then Webull basically pays us both.
          You can sell the stocks and cash out or reinvest if you wish.</p>
          <p>With the current promotion you are guaranteed at least $28 just by signing up and depositing $1.</p> 
        </div>
      </div>

      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        {<AdSummary adInformation = {1}/>}
      </div>

      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        <div>
          <h2>ibotta</h2>
          <p>Take a picture of your receipt and earn cash back on your purchases!</p>
        </div>
      </div>

      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        {<AdSummary adInformation = {0}/>}
      </div>

      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        <div>
          <h2>Upside</h2>
          <p>Earn cash back on gas and at restaurants!  I use this one frequently and it's easy to cash out with paypal.</p>
        </div>
      </div>

      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        {<AdSummary adInformation = {2}/>}
      </div>

      {/*<div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        <div>
          <h2>Cuddle Clones</h2>
          <p>I'm trying out an ad service and this was one of the options. They make custom
          stuffed animals in the likeness of yours.</p>
          <p>Looks cute and I like dogs.</p>
        </div>
      </div>

      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        {<AdSummary adInformation = {2} adNumber= {1}/>}
      </div>

      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        <div>
          <p>They even do golf head covers. lol.</p>
        </div>
      </div>      
      
      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        {<AdSummary adInformation = {2} adNumber= {0}/>}
      </div>

      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        <div>
          <h2>GameStop</h2>
          <p>Another of the options on the ad service I'm testing out.</p>
          <p>Memetastic.</p>
        </div>
      </div>      
      
      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        {<AdSummary adInformation = {0}/>}
      </div>*/}

      <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
        <div style={{"display": "flex", flexFlow:'column'}}>
          <h2>Venmo?</h2>
          <p>I guess if you really want to just support this project directly you could venmo me?</p>
          <a href='https://venmo.com/code?user_id=2471574103916544944' target="_blank">My Venmo</a>
          <img style={{maxWidth:'300px'}} alt="QR code" src={venmoQR}/>
        </div>
      </div>


    </div>
  );
}

export default Support;